var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Oh, no. Not here.")]),_c('p',[_c('img',{staticClass:"bg",attrs:{"alt":"404","src":require("./../assets/images/404.svg")}}),_c('router-link',{staticClass:"back-home",attrs:{"to":"/"}},[_vm._v("← Back home.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }